/** Matches optimistic ids created by scoutConversationController. */
export function isScoutOptimisticConversationId(conversationId: string | undefined): boolean {
  return conversationId?.startsWith("optimistic-scout-") ?? false;
}

/** @deprecated Use effectiveConversationId instead */
/** Returns a persisted conversation id, resolving optimistic ids via reconciliation map. */
export function resolvePersistedScoutConversationId(
  conversationId: string | undefined,
  reconciledConversationIdsByConversationId: Record<string, string>
): string | undefined {
  if (!conversationId) {
    return undefined;
  }

  if (isScoutOptimisticConversationId(conversationId)) {
    return reconciledConversationIdsByConversationId[conversationId];
  }

  return conversationId;
}
